import React from 'react';
import Interaction from 'Components/Map/Interaction';
import withProps from 'recompose/withProps';
import ReactDOM from "react-dom";
let createReactClass = require("create-react-class");

const Tooltip = createReactClass({
  componentDidMount() {
    this.tooltip = this.addOverlay(this.props.layer, this.props.template)
  },
  componentWillReceiveProps(newProps) {
    this.tooltip.disable();
    $("._popup").remove();
    this.tooltip = this.addOverlay(this.props.layer, newProps.template)
  },
  componentWillUnmount() {
    this.tooltip && this.tooltip.disable()
    $("._popup").remove();
  },
  render() {
    return null;
  },
  addOverlay(layer, template) {
    return layer.leafletMap.viz.addOverlay({
      type: 'tooltip',
      layer: layer.getSubLayer(0),
      position: 'bottom|right',
      fields: [this.props.interactivity.map( x => {x})],
    }).tap(
      overlay => overlay.template = (data) => "<div class='_popup'>" + template(data) + "</div>"
    )
    layer.leafletMap.tap(
      map => map.once("mouseleave", _ => this.tooltip.disable())
                .once("layeradd", _ => this.tooltip.disable())
                .once("layerremove", _ => this.tooltip.disable())
    )

  }
});

export default Tooltip;



// WEBPACK FOOTER //
// ./components/Map/Tooltip.js